import React, { useState } from "react";
import { Form, Accordion, Card } from "react-bootstrap";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import Chip from "@mui/material/Chip";

const DocumentPreview = ({ fileSelected, setFileSelected }) => {
  const [activeKey, setActiveKey] = useState(null);

  const toggleAccordion = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  // Handler para campos simples do concurso
  const handleFieldChange = (field, value) => {
    setFileSelected({
      ...fileSelected,
      [field]: value,
      changed: true,
    });
  };
  function formatDateToDDMMYYYY(dateStr) {
    if (!dateStr) return "";
    // yyyy-MM-ddTHH:mm:ss... → dd/MM/yyyy
    const match = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
      const [, y, m, d] = match;
      return `${d}/${m}/${y}`;
    }
    // yyyy-MM-dd → dd/MM/yyyy
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      const [y, m, d] = dateStr.split("-");
      return `${d}/${m}/${y}`;
    }
    // MM/dd/yyyy → dd/MM/yyyy
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
      const [a, b, c] = dateStr.split("/");
      if (parseInt(a, 10) > 12) return dateStr;
      if (parseInt(b, 10) > 12) return `${b}/${a}/${c}`;
      return `${b}/${a}/${c}`;
    }
    return dateStr;
  }

  // Handler para campos dos perfis profissionais
  const handlePerfilChange = (index, field, value) => {
    const updatedPerfis = [...fileSelected.perfisProfissionais];
    updatedPerfis[index] = {
      ...updatedPerfis[index],
      [field]: value,
      changed: true,
    };
    setFileSelected({
      ...fileSelected,
      perfisProfissionais: updatedPerfis,
      changed: true,
    });
  };

  // Handler para competências (agora objetos)
  const handleCompetenciaChange = (perfilIndex, competenciaIndex, value) => {
    const updatedPerfis = [...fileSelected.perfisProfissionais];
    const updatedCompetencias = [...updatedPerfis[perfilIndex].competencias];
    updatedCompetencias[competenciaIndex] = {
      ...updatedCompetencias[competenciaIndex],
      descricao: value,
      changed: true,
    };
    updatedPerfis[perfilIndex] = {
      ...updatedPerfis[perfilIndex],
      competencias: updatedCompetencias,
      changed: true,
    };
    setFileSelected({
      ...fileSelected,
      perfisProfissionais: updatedPerfis,
      changed: true,
    });
  };

  const generatePdfView = () => {
    const base64String = atob(fileSelected.documentBase64);
    const bytes = new Uint8Array(base64String.length);
    for (let i = 0; i < base64String.length; i++) {
      bytes[i] = base64String.charCodeAt(i);
    }
    const pdfBlob = new Blob([bytes.buffer], { type: "application/pdf" });
    return URL.createObjectURL(pdfBlob);
  };

  return (
    <div style={{ display: "flex", gap: "20px" }}>
      <div style={{ flex: 1, padding: "10px" }}>
        <iframe
          src={generatePdfView()}
          title="PDF Preview"
          style={{ width: "100%", height: "720px" }}
        />
      </div>
      <div style={{ flex: 1 }} className="scrollBar-cvmanagementModal">
        <Form>
          <Form.Group controlId="entidadeLancadora">
            <Form.Label>Entidade Lançadora</Form.Label>
            <Form.Control
              type="text"
              value={fileSelected.entidade}
              onChange={(e) => handleFieldChange("entidade", e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="tituloConcurso" className="mt-3">
            <Form.Label>Título do Concurso</Form.Label>
            <Form.Control
              type="text"
              value={fileSelected.nome}
              onChange={(e) => handleFieldChange("nome", e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="dataLimiteProposta" className="mt-3">
            <Form.Label>Data Limite para Proposta</Form.Label>
            <Form.Control
              type="text"
              value={formatDateToDDMMYYYY(fileSelected.dataLimite)}
              onChange={(e) => handleFieldChange("dataLimite", e.target.value)}
            />
          </Form.Group>

          <Accordion activeKey={activeKey}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <Chip
                color="primary"
                label={fileSelected.perfisProfissionais.length}
                variant="outlined"
                size="small"
              />
              <Form.Label>Perfis Profissionais</Form.Label>{" "}
            </div>
            {fileSelected.perfisProfissionais.map((perfil, index) => (
              <Card key={perfil.id}>
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey={index.toString()}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                  onClick={() => toggleAccordion(index.toString())}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "95%",
                    }}
                  >
                    <Chip
                      color="primary"
                      label={perfil.competencias.length}
                      variant="outlined"
                      size="small"
                    />
                    <Form.Control
                      type="text"
                      value={perfil.perfil}
                      onChange={(e) =>
                        handlePerfilChange(index, "perfil", e.target.value)
                      }
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        border: "none",
                        background: "transparent",
                        padding: "0px",
                      }}
                    />
                  </div>
                  {activeKey === index.toString() ? (
                    <FaChevronUp />
                  ) : (
                    <FaChevronDown />
                  )}
                </Accordion.Toggle>
                <Accordion.Collapse
                  eventKey={index.toString()}
                  style={{ padding: "10px" }}
                >
                  <Card.Body>
                    <div style={{ marginBottom: "16px" }}>
                      <Form.Group>
                        <Form.Label>Experiência Mínima (anos):</Form.Label>
                        <Form.Control
                          type="number"
                          value={perfil.anosExpMinima || ""}
                          onChange={(e) =>
                            handlePerfilChange(
                              index,
                              "anosExpMinima",
                              e.target.value
                            )
                          }
                        />
                      </Form.Group>
                    </div>
                    <div style={{ marginBottom: "16px" }}>
                      <Form.Group>
                        <Form.Label>Formação:</Form.Label>
                        <Form.Control
                          type="text"
                          value={perfil.formacaoNecessaria}
                          onChange={(e) =>
                            handlePerfilChange(
                              index,
                              "formacaoNecessaria",
                              e.target.value
                            )
                          }
                        />
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Label>Competências:</Form.Label>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px",
                        }}
                      >
                        {perfil.competencias.map((competencia, i) => (
                          <div key={competencia.id}>
                            <Form.Control
                              type="text"
                              value={competencia.descricao}
                              onChange={(e) =>
                                handleCompetenciaChange(
                                  index,
                                  i,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            ))}
          </Accordion>
        </Form>
      </div>
    </div>
  );
};

export default DocumentPreview;
